import styled from 'styled-components';

export const SubscriptionTabStyle = styled.div`
  position: relative;
  font-size: 16px;
  line-height: 20px;

  .info-block {
    width: 100%;
    padding: 15px;
    border-radius: 15px;
    border: 1px solid rgba(157, 157, 157, 0.4);
    background: var(--white);
  }

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    margin: 0;
    color: var(--text-color);
  }

  .list-holder {
    width: 100%;
    padding: 15px;
    border-radius: 15px;
    border: 1px solid rgba(157, 157, 157, 0.4);
    background: #f1f1f1;

    .subtitle {
      display: block;
      font-weight: 600;
      margin: 0 0 15px;
    }

    .list {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
`;
